export default "__VITE_ASSET__6fr5D1Yi__"